module.exports = __webpack_public_path__ + "static/media/yto-express.c0e8aecb.svg";